import {
    GET_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_LIST_PROGRESS, GET_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_LIST_SUCCESS, GET_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_LIST_FAILURE,
    ADD_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_PROGRESS, ADD_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_SUCCESS, ADD_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_FAILURE,
    EDIT_DELETE_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_PROGRESS, EDIT_DELETE_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_SUCCESS, EDIT_DELETE_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_FAILURE,
   
    RESET_MESSAGE,

} from '../../types/actionTypes';

const initialState = {
    customer_supplier_advancePayment: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const customer_supplier_advance_payment_reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_LIST_SUCCESS:
            return { ...state, customer_supplier_advancePayment: action.customer_supplier_advancePayment, loading: false };
        case GET_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_LIST_PROGRESS:
            return { ...state, loading: true, error: false };
        case ADD_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_PROGRESS:
            return { ...state, loading: true };
        case ADD_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_SUCCESS:
            return { ...state, customer_supplier_advancePayment: [...state.customer_supplier_advancePayment, action.payload], loading: false, error: false, message: 'Record saved successfully!' };
        case ADD_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };
        case EDIT_DELETE_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_SUCCESS:
            return {
                ...state,
                customer_supplier_advancePayment: state.customer_supplier_advancePayment.map((customer_supplier_advancePayment) =>
                customer_supplier_advancePayment.id === action.payload.id ? action.payload : customer_supplier_advancePayment
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_CUSTOMER_SUPPLIER_ADVANCE_PAYMENT_FAILURE:
            return { ...state, loading: false, error: action.payload,  message: action.payload.message};
     
        case RESET_MESSAGE:
            return { ...state, message: null }; // Reset the edit message

        default:
            return state
    }
}

export default customer_supplier_advance_payment_reducer;